import {
    DEFAULT_INSPECTOR_TAB_SLUG,
    SITE_ORIGIN,
    getInspectorTabBySlug,
    getInspectorTabCanonicalUrl,
} from './tabRoutes';

function upsertMeta(name, content, attribute = 'name') {
    if (!content) {
        return;
    }

    let element = document.head.querySelector(`meta[${attribute}="${name}"]`);

    if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute, name);
        document.head.appendChild(element);
    }

    element.setAttribute('content', content);
}

function upsertLink(rel, href) {
    if (!href) {
        return;
    }

    let element = document.head.querySelector(`link[rel="${rel}"]`);

    if (!element) {
        element = document.createElement('link');
        element.setAttribute('rel', rel);
        document.head.appendChild(element);
    }

    element.setAttribute('href', href);
}

export function getSiteOrigin() {
    if (process.env.NODE_ENV === 'production') {
        return process.env.REACT_APP_SITE_ORIGIN || SITE_ORIGIN;
    }

    return window.location.origin;
}

export function syncInspectorTabSeo(slug = DEFAULT_INSPECTOR_TAB_SLUG) {
    const tab = getInspectorTabBySlug(slug);
    const { seo } = tab;
    const canonicalUrl = getInspectorTabCanonicalUrl(slug, getSiteOrigin());

    document.title = seo.title;
    upsertMeta('description', seo.description);
    upsertMeta('keywords', seo.keywords);
    upsertLink('canonical', canonicalUrl);
    upsertMeta('og:title', seo.title, 'property');
    upsertMeta('og:description', seo.description, 'property');
    upsertMeta('og:url', canonicalUrl, 'property');
    upsertMeta('og:type', 'website', 'property');
    upsertMeta('twitter:card', 'summary', 'name');
    upsertMeta('twitter:title', seo.title, 'name');
    upsertMeta('twitter:description', seo.description, 'name');
}
